module.exports = __webpack_public_path__ + "img/menu-hair-10.cd8ef733.webp";